import React, { useEffect, useState } from 'react';

import Image from 'next/image';

import useWindowSize from '@components/common/hooks/useWindowSize';
import Text from '@components/common/Text/Text';
import { M_DEVICE } from '@components/lpc/Constants';
import Settings from '@components/lpc/Pot/AmountModule/Settings/Settings';
import { personRoles } from '@models/PotModel/personRoles';
import { potType } from '@propTypes/potTypes';
import { getItemFromStorage, setItemToStorage } from '@services/utils/StorageService';

import css from './PotHeaderBanner.module.scss';

type PotHeaderBannerProps = {
    pot: potType;
    desc: string;
    newPoolObjective: (potObjectiveType) => void;
    openSetting?: boolean;
};

const PotHeaderBanner = ({ desc, pot, newPoolObjective, openSetting }: PotHeaderBannerProps) => {
    const { width } = useWindowSize();
    const isMobile = width <= M_DEVICE;
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const handleCloseClick = () => {
        setItemToStorage('local', 'isSettingsVisible', false);
        setIsVisible(false);
    };

    useEffect(() => {
        if (getItemFromStorage('local', 'isSettingsVisible') === false) {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }
    }, []);

    return (
        !pot.isOffered && (
            <div className={`${css.container} Settings`}>
                {isMobile ? (
                    isVisible && (
                        <div className={css.container__banner_header}>
                            <Text variant={'body_02'} customClass={css.text} color={'white'}>
                                {desc}
                            </Text>
                            <div className={css.container__banner_header__img}>
                                <Image
                                    height={24}
                                    width={24}
                                    src="/front-static/icons/navigation/close-white.svg"
                                    alt="whatsapp"
                                    onClick={handleCloseClick}
                                />
                            </div>
                        </div>
                    )
                ) : (
                    <Text variant={'body_02'} customClass={css.text} color={'white'}>
                        {desc}
                    </Text>
                )}
                <div className={css.container__setting}>
                    <Settings
                        mobileView={false}
                        pot={pot}
                        isVisible={pot.personRole === personRoles.ORGANISER}
                        newPoolObjective={(objective) => newPoolObjective(objective)}
                        openSetting={openSetting}
                    />
                </div>
            </div>
        )
    );
};

export default PotHeaderBanner;
